<script>
  import PageHero from '$lib/page/Hero.svelte';
  import ContactInfo from '$lib/contacts/Info.svelte';

  export let page_hero;
  export let info;
</script>

<PageHero hero={page_hero} />
{#if info}
  <ContactInfo {info} />
{/if}
